<template>
  <div v-if="zodiacInfo" class="card border-purple-200 bg-gradient-to-br from-purple-50 to-pink-50">
    <div class="p-6 border-b border-purple-200">
      <div class="flex items-center gap-2 flex-wrap">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-purple-600">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
          <path d="M2 12h20"></path>
        </svg>
        <h3 class="text-xl font-bold">星座性格参考</h3>
        <span class="text-xs px-2 py-1 bg-purple-200 text-purple-700 rounded-full border border-purple-300">
          仅供娱乐
        </span>
      </div>
    </div>
    
    <div class="p-6 space-y-4">
      <!-- 星座名称和特质 -->
      <div class="flex flex-col sm:flex-row sm:items-center gap-3">
        <div class="text-lg px-4 py-2 text-purple-600 border-2 border-purple-300 bg-white rounded-md w-fit font-semibold">
          ✨ {{ zodiacInfo.name }}
        </div>
        <div class="flex flex-wrap gap-2">
          <span 
            v-for="(trait, index) in zodiacInfo.traits" 
            :key="index"
            class="text-xs px-2 py-1 bg-white/70 rounded-full text-purple-700 border border-purple-200"
          >
            {{ trait }}
          </span>
        </div>
      </div>

      <!-- 在恋爱中的特点 -->
      <div class="bg-white/70 rounded-lg p-4 border border-purple-200">
        <h4 class="font-semibold text-sm text-purple-700 mb-3 flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
            <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
          </svg>
          {{ zodiacInfo.name }}在恋爱中的特点
        </h4>
        <p class="text-sm text-gray-700 leading-relaxed">
          {{ trait }}
        </p>
      </div>

      <!-- 星座建议 -->
      <div class="bg-gradient-to-r from-purple-100/50 to-pink-100/50 rounded-lg p-4 border border-purple-200">
        <h4 class="font-semibold text-sm text-purple-700 mb-3 flex items-center gap-2">
          💡 {{ tipTitle }}
        </h4>
        <p class="text-sm text-gray-700 leading-relaxed">
          {{ tip }}
        </p>
      </div>

      <!-- 特别说明 -->
      <div class="bg-white/50 border border-purple-200 rounded-lg p-3">
        <p class="text-xs text-purple-700 flex items-start gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-3 h-3 mt-0.5 flex-shrink-0">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" x2="12" y1="16" y2="12"></line>
            <line x1="12" x2="12.01" y1="8" y2="8"></line>
          </svg>
          <span>
            <strong>特别说明：</strong>星座性格学没有科学依据，以上内容基于流行文化和星座学传统，纯属娱乐参考，不代表任何科学结论。{{ assessmentType === 'self' ? '你的' : 'Ta的' }}RPI评估分数完全基于心理学理论和实际回答，与星座无关。每个人都是独特的个体，不应被星座标签所限制。
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { zodiacData } from '../../data/zodiacData.js'

export default {
  name: 'ZodiacReference',
  props: {
    zodiacSign: {
      type: [Number, String],
      default: 0
    },
    assessmentType: {
      type: String,
      default: 'self'
    }
  },
  mounted() {
    console.log('=== 星座组件调试 ===')
    console.log('zodiacSign prop:', this.zodiacSign)
    console.log('zodiacInfo:', this.zodiacInfo)
    console.log('assessmentType:', this.assessmentType)
  },
  computed: {
    zodiacInfo() {
      const sign = Number(this.zodiacSign)
      console.log('计算zodiacInfo - sign:', sign)
      
      // 如果zodiacSign为0、null或undefined，不显示星座信息
      if (!sign || sign === 0) {
        console.log('zodiacSign无效，不显示星座信息')
        return null
      }
      
      const info = zodiacData[sign] || null
      console.log('zodiacData[sign]:', info)
      return info
    },
    trait() {
      if (!this.zodiacInfo) return ''
      return this.assessmentType === 'self' ? this.zodiacInfo.self : this.zodiacInfo.partner
    },
    tip() {
      if (!this.zodiacInfo) return ''
      return this.assessmentType === 'self' 
        ? this.zodiacInfo.tips.self 
        : this.zodiacInfo.tips.partner
    },
    tipTitle() {
      if (!this.zodiacInfo) return ''
      return this.assessmentType === 'self' 
        ? '给你的星座建议' 
        : `如何应对${this.zodiacInfo.name}的Ta`
    }
  }
}
</script>

